import { DynamicObjectInterface } from '../../sdk/type';
import { FAIcon, IconStyle, Theme } from '../../ui/components';
import { GetColumnsType } from '../../ui/components/TableContainer/types/propsTypes';
import { UTCToCustomFormat } from '../../ui/utils';

export const getParticipationHistoryConfig: GetColumnsType = (
  styles: DynamicObjectInterface,
  translation: DynamicObjectInterface,
  cb: DynamicObjectInterface,
) => {
  return [
    {
      key: 'campaignName',
      text: 'Campaign Name',
      sortable: true,
      width: 25,
      render: (object: DynamicObjectInterface) => <span>{object.campaignName}</span>,
    },
    {
      key: 'enrollmentDate',
      text: 'Join Date',
      sortable: true,
      width: 20,
      render: (object: DynamicObjectInterface) => (
        <span>{UTCToCustomFormat(object.enrollmentDate, 'MMMM D, YYYY')}</span>
      ),
    },
    {
      key: 'progressStatus',
      text: 'Status',
      sortable: true,
      width: 25,
      render: (object: DynamicObjectInterface) => <span>{object.progressStatus}</span>,
    },
    {
      key: 'actions',
      width: 30,
      text: '',
      render: (object: DynamicObjectInterface) => (
        <div
          className={`${styles['icon-container']} ${object.progressStatus !== 'Completed' || !object.s3Link ? styles['inactive'] : ''}`}
        >
          <FAIcon
            onMouseOver={() => {}}
            iconName={'eye'}
            onClick={e => {
              if (object.code && object.progressStatus === 'Completed' && object.s3Link) {
                cb?.onView({ teamId: object.teamId, campaignId: object.campaignId, code: object.code });
                e.stopPropagation();
              }
            }}
            theme={Theme.BLACK}
            title={'View Certificate'}
          />
          <FAIcon
            iconName={'download'}
            iconStyle={IconStyle.SOLID}
            onClick={e => {
              if (object.code && object.progressStatus === 'Completed' && object.s3Link) {
                cb?.onDownload({ teamId: object.teamId, campaignId: object.campaignId, code: object.code });
                e.stopPropagation();
              }
            }}
            theme={Theme.BLACK}
            title={'Download Certificate'}
          />
          <FAIcon
            iconName={'share-alt'}
            iconStyle={IconStyle.SOLID}
            onClick={e => {
              if (object.code && object.progressStatus === 'Completed' && object.s3Link) {
                cb?.onShare({ teamId: object.teamId, campaignId: object.campaignId, code: object.code });
                e.stopPropagation();
              }
            }}
            theme={Theme.BLACK}
            title={'Share Certificate'}
          />
        </div>
      ),
    },
  ];
};
